import { config } from "@/config";
import { useMutation } from "@tanstack/react-query";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { DiagramInfo } from "@/types/diagram";
import { apiFetch } from "@/lib/api-client";

export default function useDeleteDiagramService(
  onSuccess?: (res: DiagramInfo) => void,
  onError?: (error: Error) => void
) {
  const { getAuthHeaders } = useAuthHeaders();

  const deleteDiagram = async (id: string): Promise<any> => {
    const url = `${config.isometricApiUrl}/diagram/${id}`;

    try {
      const response = await apiFetch(url, {
        method: "DELETE",
        headers: getAuthHeaders(),
      });

      // Check if the response is ok (status code in the range 200-299)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json(); // Parse the JSON response
    } catch (error) {
      console.error("Error:", error); // Handle errors
    }
  };

  return useMutation({
    mutationFn: deleteDiagram,
    onSuccess: (data) => {
      // Invalidate all document-related queries to ensure fresh data
      //   queryClient.invalidateQueries({
      //     queryKey: ["document-by-id"],
      //   });

      onSuccess?.(data);
    },
    onError,
  });
}
